
import api from './api'
import { useDownload } from '@/helpers/download'

export default {
    
    count(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    deleteAddress(id, clientAddressId) {

        return api.delete('/utilisateurs/' + id + '/addresses/' + clientAddressId, {})
            
    },

    deleteHabilitation(id, habilitationId) {

        return api.delete('/utilisateurs/' + id + '/habilitations/' + habilitationId, {})
            
    },

    get(id) {

        return api.get('/utilisateurs/' + id, {})
            .then( json => {

                let utilisateur = json.data

                return utilisateur
            })
            
    },

    getAddresses(id) {

        return api.get('/utilisateurs/' + id + '/addresses', {})
            .then( json => json.data )
            
    },

    getAll() {

        return api.get('/utilisateurs/all', {})
            .then( json => json.data )
            
    },

    getClients(id) {

        return api.get('/utilisateurs/' + id + '/clients', {})
            .then( json => json.data )
            
    },

    getHabilitations(id) {

        return api.get('/utilisateurs/' + id + '/habilitations', {})
            .then( json => json.data )
            
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/utilisateurs/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },        

    list(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( json => json.data )
            
    },

    putAddress(id, clientAddressId) {

        return api.put('/utilisateurs/' + id + '/addresses/' + clientAddressId, {})
            
    },

    putHabilitation(id, habilitationId) {

        return api.put('/utilisateurs/' + id + '/habilitations/' + habilitationId, {})
            
    },

    patch(utilisateur) {
        return api.patch('/utilisateurs/' + utilisateur.id, utilisateur)
    },

    post(utilisateur) { 
        return api.post('/utilisateurs', utilisateur)
    },

    search(params = {}) {

        return api.get('/utilisateurs', { params })
            .then( json => json.data )            
    } 
}
